// extracted by mini-css-extract-plugin
export default {"albums":"dXUA16TYewrSa64ICRNw","album":"EVBGLFjtcQ0B5Xq5eCIE","albumImage":"Sv21kjtzxZPWQ3b94Hk5","container":"TzSYUKNJgNaiGuSTN2pZ"};